
import { Component, Mixins } from "vue-property-decorator";

@Component({
})
export default class EditorItemMixin extends Mixins() {
  get rootStyleProperties(): any {
    return {
      padding: "5px",
    };
  }
}
